import { render, staticRenderFns } from "./FirstBookDailyReviewPanel.vue?vue&type=template&id=5c1f559a&scoped=true&"
import script from "./FirstBookDailyReviewPanel.vue?vue&type=script&lang=js&"
export * from "./FirstBookDailyReviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./FirstBookDailyReviewPanel.vue?vue&type=style&index=0&id=5c1f559a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1f559a",
  null
  
)

export default component.exports